import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2025fb83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head-info" }
const _hoisted_2 = { class: "main-info" }
const _hoisted_3 = { class: "name head-wrap" }
const _hoisted_4 = {
  key: 0,
  class: "check-wrap nongfu-checkbox-wrap"
}
const _hoisted_5 = {
  key: 1,
  class: ""
}
const _hoisted_6 = {
  key: 0,
  class: "infos"
}
const _hoisted_7 = { class: "detail-info" }
const _hoisted_8 = {
  key: 0,
  class: "tips-item"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))

import { JijiaDeviceCardInfoListItem } from '@/types/insurance'
import { withDefaults, computed, ref } from 'vue'
import { Checkbox } from 'vant'
import { useWatchPropsItem } from '@/compositions/useWatch'


export default /*#__PURE__*/_defineComponent({
  __name: 'device-card-info-old',
  props: {
    data: { default: () => ({
      headInfo: {
        name: '',
        img: '',
        sn: '',
        model: '',
        activeTime: '',
      },
      checked: false,
      sn: '555',
    }) },
    round: { type: Boolean, default: false },
    imgSize: { default: 48 }
  },
  emits: ['checkClick'],
  setup(__props: any, { emit: emits }) {

const props = __props as { data: JijiaDeviceCardInfoListItem, round: boolean, imgSize: number };



const useCheckbox = computed(() => !!props.data.useCheckbox)
const useCustom = computed(() => !!props.data.useCustom)

const headInfo = computed(() => {
  return props.data.headInfo
})
const checked = ref(props.data.checked)
const imgStyle = computed(() => {
  return `background-image: url(${props.data.headInfo.img});width: ${props.imgSize}px;height: ${props.imgSize}px`
})
const getWrapClass = computed(() => {
  const arr = []
  if (props.round) {
    arr.push('card-round')
    if (checked.value) {
      arr.push('card-round-active')
    }
  }
  return arr.join(' ')
})
useWatchPropsItem(props, 'data', () => {
  console.log('2', 2)
  if (props.data.checked !== checked.value) {
    checked.value = props.data.checked
  }
})
function clickHandle() {
  emits('checkClick', props.data)
}
function wrapClickHandle() {
  if (useCheckbox.value) {
    clickHandle()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-wrap", _unref(getWrapClass)]),
    onClick: wrapClickHandle
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "img",
        style: _normalizeStyle(_unref(imgStyle))
      }, null, 4),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(_unref(headInfo).name), 1),
          (_unref(useCheckbox))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_unref(Checkbox), {
                  modelValue: __props.data.checked,
                  onClick: _withModifiers(clickHandle, ["stop"]),
                  "icon-size": "20px"
                }, null, 8, ["modelValue", "onClick"])
              ]))
            : _createCommentVNode("", true),
          (_unref(useCustom))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "customRight", { data: __props.data })
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(headInfo).mainInfos)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headInfo).mainInfos, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("ul", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.detailInfos, (listItem, listIndex) => {
        return (_openBlock(), _createElementBlock("li", { key: listIndex }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItem, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "",
              key: index
            }, _toDisplayString(item), 1))
          }), 128))
        ]))
      }), 128))
    ]),
    (__props.data.tips)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", null, _toDisplayString(__props.data.tips), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})